import type { ReactNode } from 'react'
import cx from 'classnames'
import styles from './TableEmptyState.module.css'

interface TableEmptyStateProps {
  /**
   * Adds a top border when true.
   */
  bordered?: boolean
  children?: ReactNode
}

/**
 * The TableEmptyState
 */
export function TableEmptyState({ children, bordered }: TableEmptyStateProps) {
  return (
    <div className={cx(styles.root, bordered && styles.bordered)}>
      {children}
    </div>
  )
}
